module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_SE-386f769f20556deab3bb049b5f5003cf.svg";